import { first } from 'lodash';

var Bootstrap = Esk.Helper.Bootstrap;

var PASSWORD_FIELD_ID = "Password",
  PASSWORD_FIELD_REF = "Password",
  PASSWORD_FIELD_NAME = "password";

var PASSWORD_CONFIRM_FIELD_ID = "PasswordConfirm",
  PASSWORD_CONFIRM_FIELD_REF = "PasswordConfirm",
  PASSWORD_CONFIRM_FIELD_NAME = "confirmPassword";

var TERMS_FIELD_ID = "Terms",
  TERMS_FIELD_REF = "Terms",
  TERMS_FIELD_NAME = "terms";

var FORM_REF = "Form";

var validationRules = require('./validation');

var WithError = require('./../../../utils/mixins/withError');
var ActivateAccount = React.createClass({

  propTypes: {
    onSubmit: React.PropTypes.func,
    invalidToken: React.PropTypes.bool,
    organisationName: React.PropTypes.string
  },

  componentDidMount(){
    var {t} = this.props;
    var form = this.refs[FORM_REF];
    $(form).validate(validationRules(t));
  },

  render(){
    var {t, error} = this.props;

    return (
      this._getContent()
    );
  },

  _getError(){
    var { error, invalidToken, organisationName } = this.props;

    if (!error && !invalidToken) {
      return null;
    }

    var errorMessage = invalidToken
      ? Esk.Constants.ConstantsHelper.Error.ACCOUNT_ACTIVATE_FAILURE.getAccountValidationError(organisationName)
      : first(error);

    return <Esk.Helper.Ui.ErrorMessage errorMessage={errorMessage}/>;
  },

  _getContent() {
    var { t, invalidToken, organisationName, isParent } = this.props;

    if (invalidToken) {
      return (
        <div className="well no-padding">
          <form className="smart-form client-form" ref={FORM_REF}
                onSubmit={this._onSaveHandler}>
            <header>
              {t("Activate Your Account")}
            </header>

            <fieldset>

              {this._getError()}
            </fieldset>
            <Bootstrap.FormActionsAccount>
            </Bootstrap.FormActionsAccount>
          </form>
        </div>
      );
    }

    return (
      <div className="well no-padding">

        <h2
          display-if={isParent}
          className="esk-security-page-heading"
        >
          {t('Welcome to the {{organisationName}} Parent Suite.', { organisationName })}
          <br/>
          {t('Please complete the setup below.')}
        </h2>

        <h2 display-if={!isParent}
            className="esk-security-page-heading"
        >
          {t('Please enter the password you want to set for your account below.')}
        </h2>

        <form className="smart-form client-form" ref={FORM_REF}
              onSubmit={this._onSaveHandler}>
          <header>
            {t("Activate Your Account")}
          </header>

          <fieldset>

            {this._getError()}

            <Bootstrap.FormGroupAccount
              elementId={PASSWORD_FIELD_ID}
              label={this._getFieldLabel(PASSWORD_FIELD_ID)}
            >
              <Esk.Helper.InputTooltip
                helpText={Esk.Constants.ConstantsHelper.Message.Account.passwordTooltip}>
                <input id={PASSWORD_FIELD_ID}
                       type="password"
                       className="form-control"
                       ref={PASSWORD_FIELD_REF}
                       name={PASSWORD_FIELD_NAME}
                       placeholder={t("Password")}
                />
              </Esk.Helper.InputTooltip>
            </Bootstrap.FormGroupAccount>

            <Bootstrap.FormGroupAccount
              elementId={PASSWORD_CONFIRM_FIELD_ID}
              label={this._getFieldLabel(PASSWORD_CONFIRM_FIELD_ID)}
            >
              <input id={PASSWORD_CONFIRM_FIELD_ID}
                     type="password"
                     className="form-control"
                     ref={PASSWORD_CONFIRM_FIELD_REF}
                     name={PASSWORD_CONFIRM_FIELD_NAME}
                     placeholder={t("Confirm Password")}
              />
            </Bootstrap.FormGroupAccount>

            <Bootstrap.FormGroupAccount
              type="checkbox"
              elementId={TERMS_FIELD_ID}
              label={this._getFieldLabel(TERMS_FIELD_ID)}
            >
              <input id={TERMS_FIELD_ID}
                     type="checkbox"
                     ref={TERMS_FIELD_REF}
                     name={TERMS_FIELD_NAME}
              />
            </Bootstrap.FormGroupAccount>

          </fieldset>

          <Bootstrap.FormActionsAccount>
            <button className="btn btn-primary"
                    type="submit">{t("Activate")}</button>
          </Bootstrap.FormActionsAccount>
        </form>
      </div>
    );

  },

  _getFieldLabel(fieldId){
    var {t} = this.props;
    switch (fieldId) {
      case PASSWORD_FIELD_ID:
        return t("New Password");
      case PASSWORD_CONFIRM_FIELD_ID:
        return t("Confirm password");
      case TERMS_FIELD_ID:
        return [
          <i key='sep'/>,
          <span key='content'
                dangerouslySetInnerHTML={
                            {
                                "__html": this._getTermsLink()
                            }}
          />];
    }

    return "";
  },

  _getTermsLink(){
    const { t, isParent } = this.props;
    const termsLink = isParent
      ? Esk.Config.parentTermsAndConditionsUrl
      : Esk.Config.termsAndConditionsUrl;
    return t("I agree with the <a href='%s' target='_blank'>Terms and Conditions</a>.", {
      context: 'security',
      escapeValue: false,
      postProcess: 'sprintf',
      sprintf: [termsLink]
    });
  },


  _onSaveHandler(e){
    e.preventDefault();
    var {onSubmit} = this.props;
    if (!onSubmit) return;

    var form = this.refs[FORM_REF];
    if (!$(form).valid()) return;

    var data = {};
    data.password = this.refs[PASSWORD_FIELD_REF].value;
    data.confirmPassword = this.refs[PASSWORD_CONFIRM_FIELD_REF].value;
    onSubmit(data);
  }
});


module.exports = WithError(ActivateAccount);
